import { render } from "./CustomerVisits.vue?vue&type=template&id=11b8db3f&scoped=true&ts=true"
import script from "./CustomerVisits.vue?vue&type=script&lang=ts"
export * from "./CustomerVisits.vue?vue&type=script&lang=ts"

import "./CustomerVisits.vue?vue&type=style&index=0&id=11b8db3f&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-11b8db3f"]])

export default __exports__